import React from 'react';
// import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';
import { Row, Col } from 'react-bootstrap';
import SignupFormFields from './SignupFormFields';

class WhiteLabelClientRegistration extends EntityPropsUpdater {
  render() {
    const {
      entity,
      entityLoaded,
      disabled,
      inModal,
      intl: { messages },
    } = this.props;

    return (
      <div className="clearfix">
        {entityLoaded && (
          <div>
            <p className="m-t-15 m-l-15 form-group-title">
              <i className="far fa-address-card" /> {messages.client_registration_title}
            </p>

            <Row>
              <Col xs={12} md={inModal ? 12 : 4}>
                <div className="panel panel-transparent">
                  <div className="panel-body">
                    <div className="m-t-15 form-group-attached">
                      <FormSwitchery
                        name="isClientRegistrationAllowed"
                        checked={entity.getIsClientRegistrationAllowed()}
                        value
                        label={messages.is_client_registration_allowed}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>

                    <div className="m-t-15 form-group-attached">
                      <FormSwitchery
                        name="isEmailValidationEnabled"
                        checked={entity.getIsEmailValidationEnabled()}
                        value
                        label={messages.is_email_validation_enabled}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                    <div className="form-group-attached">
                      <FormInput
                        label={messages.email_validation_pattern}
                        name="emailValidationPattern"
                        value={entity.getEmailValidationPattern()}
                        meta={entity.getEmailValidationPatternMetaInformation()}
                        validation={entity.getEmailValidationPatternValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                        placeholder="^[a-z][a-z0-9_.-]*@example\.com$"
                      />
                      <FormInput
                        label={messages.confirmation_email_cc}
                        name="confirmationEmailCC"
                        value={entity.getConfirmationEmailCC()}
                        meta={entity.getConfirmationEmailCCMetaInformation()}
                        validation={entity.getConfirmationEmailCCValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                        placeholder="hr@example.com"
                      />
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={inModal ? 12 : 8}>
                <SignupFormFields entity={entity} updateEntity={this.updateEntity} />
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
WhiteLabelClientRegistration.defaultProps = {
  inModal: false,
};

// export default WhiteLabelClientRegistration;
export default injectIntl(WhiteLabelClientRegistration);
